export default __webpack_public_path__ + "static/Ziadost_o_zapis_do_evidencie_vodicov_17_rocnych_Autoskola_Hron_sro-08256b6c33fcd1e51c0ac6fa29c8ad23.pdf";